import NoDataComponent from '@Components/General/Feedback/no-data-component';
import { AddCircleOutlineRounded } from '@mui/icons-material';
import { Button } from '@mui/material';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

const NoDrafts = () => {
    const { t } = useTranslation();

    return (
        <NoDataComponent
            primary={t('prompts:noData.emailDrafts.noData.primary')}
            secondary={t('prompts:noData.emailDrafts.noData.secondary')}
            Icon="contract_edit"
            action={
                <Button
                    startIcon={<AddCircleOutlineRounded />}
                    color="primary"
                    LinkComponent={Link}
                    to="new"
                >
                    {t('Create Email')}
                </Button>
            }
        />
    );
};

export default NoDrafts;
